document.addEventListener('DOMContentLoaded', function() {
    // Only run on mobile devices
    if (window.innerWidth > 768) return;

    const stickyElement = document.querySelector('.product-info__add-to-cart');

    if (!stickyElement) return;

    let isSticky = false;
    // Remove the is-sticky class initially to get the element's natural position
    const hadStickyClass = stickyElement.classList.contains('is-sticky');
    stickyElement.classList.remove('is-sticky');

    // Create a sentinel element that stays at the original position
    const sentinel = document.createElement('div');
    sentinel.setAttribute('id', 'sticky-sentinel');
    sentinel.style.position = 'absolute';
    sentinel.style.height = '0';
    sentinel.style.width = '100%';
    sentinel.style.pointerEvents = 'none';
    sentinel.style.visibility = 'hidden';

    // Insert sentinel before the sticky element
    stickyElement.parentNode.insertBefore(sentinel, stickyElement);


    // Intersection Observer to detect when element's original position enters viewport
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Sentinel is in viewport - element should be in its natural position
                    stickyElement.classList.remove('is-sticky');
                    isSticky = false;
                } else {
                    const rect = sentinel.getBoundingClientRect(); // Use parent to know its natural position
                    if (rect.top > window.innerHeight) { // If the top of the parent is below the viewport
                        // It means we are scrolling down and are above the element's natural position
                        // So it should be sticky at the bottom
                        if (!isSticky) {
                            stickyElement.classList.add('is-sticky');
                            isSticky = true;
                        }
                    } else {
                        // If rect.top <= window.innerHeight but not intersecting,
                        // it means we've scrolled past it. So it should not be sticky.
                        if (isSticky) {
                            stickyElement.classList.remove('is-sticky');
                            isSticky = false;
                        }
                    }
                }
            });
        },
        {
            root: null,
            threshold: 0,
            rootMargin: '0px'
        }
    );

    // Start observing
    observer.observe(sentinel);

    // Restore sticky class if it was there initially
    if (hadStickyClass) {
        stickyElement.classList.add('is-sticky');
    }

    // Prevent anchor links from triggering re-renders
    document.addEventListener('click', function (e) {
        const anchor = e.target.closest('a[href^="#"]');
        if (anchor) {
            const hash = anchor.getAttribute('href');
            const targetElement = document.querySelector(hash);

            if (targetElement) {
                e.preventDefault();
                targetElement.scrollIntoView({behavior: 'smooth', block: 'start'});
                // Update URL without triggering navigation
                history.pushState(null, null, hash);
            }
        }
    });
});
